import { ReclaimProfileSchema } from "@redotech/redo-dispute-settings-common/reclaim-profile";
import * as z from "zod";

// Derived reclaim-profile placeholder values (from team + Shopify) for the Profile
// tab. Output reuses ReclaimProfileSchema so saved values and defaults share a shape.
export const getReclaimProfileDefaults = {
  name: "getReclaimProfileDefaults" as const,
  input: z.object({}),
  output: ReclaimProfileSchema,
};
